import React from "react";
import '../../css/components/controls/HrnbTabs.css'

export function HrnbTabs({ value, onChange, children, className = "", ...props }) {
    // value — индекс или id активной вкладки
    // onChange — (newValue) => void
    return (
        <div className={`hrnb-tabs ${className}`} {...props}>
            {React.Children.map(children, (child, idx) => {
                if (!React.isValidElement(child)) return null;
                return React.cloneElement(child, {
                    active: child.props.value === value || idx === value,
                    onClick: onChange ? () => !child.props.disabled && onChange(child.props.value ?? idx) : undefined
                });
            })}
        </div>
    );
}

export function HrnbTab({
                            className = "",
                            icon,
                            label,
                            active = false,
                            disabled = false,
                            onClick,
                            ...props
                        }) {
    const handleClick = (e) => {
        if (onClick && typeof onClick === 'function') {
            onClick(e);
        }
    };

    return (
        <button
            className={`hrnb-tab${active ? " hrnb-tab--active" : ""}${disabled ? " hrnb-tab--disabled" : ""} ${className}`}
            disabled={disabled}
            type="button"
            tabIndex={disabled ? -1 : 0}
            onClick={handleClick}
            {...props}
        >
            {icon && <span className="hrnb-tab__icon">{icon}</span>}
            <span className="hrnb-tab__label">{label}</span>
        </button>
    );
}
